import { useTranslation } from "react-i18next";

import { ModalPage, BookingLocationCellItem } from "@organisms";
import { Div, FlexCol, Subtitle } from "@quarks";
import {
  getBuildingIdsThatRequireWorkspaceBooking,
  getBuildingSections,
} from "@lib/store/src/data/timeslots/selectors/getBuildingSections";
import { Building, useAppSelector } from "@lib/store";
import { useModal } from "@hooks";

type Props = {
  date: string;
  onSelect: (building: Building) => void;
  onBack?: () => void;
  onClose?: () => void;
};

export const BookingBuildingSelectionCard = ({ date, onSelect, onBack, onClose }: Props) => {
  const { t } = useTranslation();
  const { closeModal } = useModal();

  const buildingIdsWithRequiredWorkspaceBooking = useAppSelector(getBuildingIdsThatRequireWorkspaceBooking);
  const buildingSections = useAppSelector(state => getBuildingSections(state, date));

  return (
    <ModalPage
      onClose={onClose ? onClose : closeModal}
      onBack={onBack}
      title={t("translation:Building")}
      contentClassName="px-5">
      <FlexCol gap={32}>
        <Div>
          {buildingSections.open.map(b => (
            <BookingLocationCellItem
              key={`open_${b.id}`}
              icon="office"
              isActive={false}
              isDisabled={false}
              canNavigate
              title={b.name}
              subTitle={
                buildingIdsWithRequiredWorkspaceBooking.has(b.id) ? t("workplace:WorkspaceBookingRequired") : null
              }
              onClick={() => onSelect(b)}
            />
          ))}

          {buildingSections.closed.length > 0 && (
            <div className="mt-5">
              <Subtitle fontSize="sm">{t("workplace:WorkspaceGroupUnavailable")}</Subtitle>

              {buildingSections.closed.map(b => (
                <BookingLocationCellItem
                  key={`closed_${b.id}`}
                  icon="office"
                  isActive={false}
                  isDisabled
                  canNavigate={false}
                  title={b.name}
                  subTitle={t("workplace:ClosedOffice")}
                  onClick={() => null}
                />
              ))}
            </div>
          )}
        </Div>

        <Subtitle fontSize="sm">{t("workplace:NoOfficeInTheList")}</Subtitle>
      </FlexCol>
    </ModalPage>
  );
};
